import React from 'react';
import { NumberField, useRecordContext } from 'react-admin';

const NumberCurrencyField = ({ ...props }) => {
    const record = useRecordContext(props);

    if (!record) {
        return null;
    }

    const currency = record?.currency || 'eur';

    return (
        <NumberField
            record={record}
            options={{ style: 'currency', currency, maximumFractionDigits: 2 }}
            {...props}
        />
    );
};

export default NumberCurrencyField;
